import React from "react";
import useAppContext from "../../../../context/useAppContext";
import { SectionHeaderWrapper } from "../../../../shared/SectionHeaderWrapper";
import NoPermissionsBlock from "../../../../common/NoPermissionsBlock";
import CustomizationViewPublishButtons from "../helpers/CustomizationViewPublishButtons";
import ConfigurationBrandingLogoCard from "../cards/ConfigurationBrandingLogoCard";
import ConfigurationBrandingToggleCard from "../cards/ConfigurationBrandingToggleCard";
import ConfigurationBrandingWhiteLabelGuideCard from "../cards/ConfigurationBrandingWhiteLabelGuideCard";

const ConfigurationBrandingSettingsPage = () => {
  // HOOKS
  const { isUserPrivileged } = useAppContext();

  return isUserPrivileged ? (
    <SectionHeaderWrapper
      title="Branding"
      subtitle="Customize Merge Link to show your brand"
      buttons={<CustomizationViewPublishButtons />}
    >
      <ConfigurationBrandingLogoCard />
      <ConfigurationBrandingToggleCard />
      <ConfigurationBrandingWhiteLabelGuideCard />
    </SectionHeaderWrapper>
  ) : (
    <NoPermissionsBlock restrictedPageName="White-label guides" />
  );
};

export default ConfigurationBrandingSettingsPage;
